var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wc-team-logo"},[(_vm.logoSrc && !_vm.failed)?_c('img',{attrs:{"src":_vm.logoSrc,"alt":_vm.name},on:{"error":function($event){_vm.failed = true}}}):_c('span',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }